import * as React from "react";
import { Menu } from "semantic-ui-react";

import { getEnvironmentName } from "../getEnvironmentName";

import "./styles/header.scss";

export const EnvironmentNameMenuItemOld = () => {
    const environmentName = getEnvironmentName();

    if (environmentName?.toLocaleUpperCase() === "LIVE")
    {
        return <></>;
    }

    return (
        <Menu.Item>
            <span className="header-environment-name">
                {environmentName}
            </span>
        </Menu.Item>
    );
};
